<template>
  <div>
  
  
  
  <h4  slot="header" class="title">
			Associate
			</h4>
		 <card class="form-horizontal">


		   <div style="padding-bottom:30px;">
		  <br/><strong>Associate's Name:</strong> {{associate.user.user_info.first_name}} {{associate.user.user_info.last_name}}	
		   <br/><strong>Email:</strong> {{associate.user.email}}
		   </div>
   
   
		  </card>
        <!-- end card-->
        
        
  
       
       <div style="margin-top:90px;">
       <h5 style="font-weight:bold;">Commission</h5>
  		</div>
		
        <div class="card" style="margin-bottom:50px">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="commission">
                  <el-table-column label="Value Date">
            		<template slot-scope="scope">
            			{{scope.row.date_str}}
            		</template>
               </el-table-column>
                 <el-table-column label="Title">
            		<template slot-scope="scope">
            			{{scope.row.title}}
            		</template>
               </el-table-column>
               
               
               <el-table-column label="Amount">
            		<template slot-scope="scope">
            			${{scope.row.amount}}
            		</template>
               </el-table-column>
            		
            		
     			 <el-table-column label="">
            		<template slot-scope="scope">
            			 <p-button  type="danger"  @click="deleteCommission(scope.row)">
                 			 <i slot="label" class="nc-icon nc-simple-remove"></i> Delete
                		</p-button>
          
                		
                		
					</template>
               </el-table-column>
                
           
                 
                  
                 
            </el-table>

          </div>
        </div>
        
        
        
  
    </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {

      	this.initPage();
    },
    
     
    data () {
      return {
        coy:[],
        commission:[],
	    associate:{
        	user:{user_info:[]},
        },    	eid: this.$route.params.eid,
		account: {
          email: '',
        },
        modelValidations: {
          title: {
          },
          description: {
          },
          email: {
            required: true,
            email:true,
          },
          due_date: {
          	required: true,
          },
         
          
        },
      }
    },
    methods:{
      goToEntity(){
	  	   this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    getError(fieldName) {
        return this.errors.first(fieldName)
      },
      
      addCommission(row){
      	this.$router.push( '/add-commission/' + row.user.id);
      },
      viewCommission(row){
      	this.$router.push( '/view-commission/' + row.user.id);
      },
      
      deleteCommission(row){
      		const vm = this;
      		swal({
					title: 'Are you sure?',
					text: 'The selected commission will be deleted.',
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes',
					buttonsStyling: false
				  }).then(function () {
					 const vm2 = vm;
					 let uri = vm.$base_url+'/api/v1/entities/post/delete_commmission/'+vm.$route.params.aid;
					
					 ApiService.post(uri, row).then(response => {
	
							swal({
							  title: 'Deleted',
							  text: 'Commission has been deleted successfully.',
							  type: 'success',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
							}).then(function () {
								vm2.initPage();
							
							})
							//end swal
						
						
					})


				  })//end swal
      
      },
	  grantAccess(row){
	  
				const vm = this;

				swal({
					title: 'Are you sure?',
					text: 'You are giving the associate access to this entity.',
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes',
					buttonsStyling: false
				  }).then(function () {
					 const vm2 = vm;
					 let uri = vm.$base_url+'/api/v1/entities/post/grant_associate_access/' +  vm.$route.params.eid;
					
					 ApiService.post(uri, row).then(response => {
					
					 
							swal({
							  title: 'Access Granted',
							  text: 'Access to this entity has been granted to the associate',
							  type: 'success',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
							}).then(function () {
								vm2.initPage();
							
							})
							//end swal
						
					})


				  })//end swal
	 
	    },
	    initPage(){
	    	let uri = this.$base_url+'/api/v1/entities/get/commission/'+ this.$route.params.aid;
			 ApiService.get(uri).then(response => {
				this.commission = response.data.commission;
				this.associate = response.data.associate;
			})
	    },
	   
	  
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


